<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mt-5">
                <div v-if="loading">
                  <LoadingProgress />
                </div>
                <div v-else>
                  <v-row class="px-5">
                    <v-col
                      style="padding-bottom: 5px"
                      v-for="(category, index) in data"
                      :key="index"
                      cols="6"
                    >
                      <v-card
                        :style="getBackgroundImage(index)"
                        style="border-radius: 10px; height: 100%"
                      >
                        <v-card-title
                          :style="getTextStyle()"
                          @click="handleClick(category)"
                        >
                          <v-row
                            align="center"
                            no-gutters
                            justify="space-between"
                          >
                            <v-col cols="11">
                              {{
                                category.CategoryID === 0
                                  ? $t(category.CategoryNameTR)
                                  : category.CategoryNameTR
                              }}
                            </v-col>
                            <v-col class="d-flex justify-end" cols="1">
                              <v-icon style="font-size: 24px; color: white">
                                mdi-chevron-right
                              </v-icon>
                            </v-col>
                          </v-row>
                        </v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import PostService from "@/services/PostService";

export default {
  data() {
    return {
      data: [],
      imagePalette: [
        { imageUrl: require("../../../public/images/academy/yellow.png") },
        { imageUrl: require("../../../public/images/academy/green.png") },
        { imageUrl: require("../../../public/images/academy/pink.png") },
        { imageUrl: require("../../../public/images/academy/orange.png") },
        { imageUrl: require("../../../public/images/academy/purple.png") },
        { imageUrl: require("../../../public/images/academy/blue.png") },
      ],
      loading: false,
    };
  },
  components: {
    LoadingProgress,
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    handleClick(category) {
      category.CategoryNameTR === "labels.forYou"
        ? this.$router.push({
            name: "vizgoCategoryDetail",
            params: { id: 2 },
          })
        : category.Children.length == 0 || category.IsChildrenPassive
        ? this.$router.push({
            path: `/academySearch`,
            query: { Id: category.Id, Name: category.CategoryNameTR },
          })
        : this.$router.push({
            name: `academySubCategories`,
            params: { id: category.Id },
          });
    },
    getBackgroundImage(index) {
      const imageEntry =
        this.imagePalette[index % this.imagePalette.length].imageUrl;
      let imageUrl;

      if (typeof imageEntry === "string") {
        imageUrl = imageEntry;
      } else if (imageEntry.default) {
        imageUrl = imageEntry.default;
      } else {
        console.error("Invalid image entry:", imageEntry);
        return {};
      }

      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
    getTextStyle() {
      if (this.$vuetify.breakpoint.xs) {
        return {
          color: "white",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "14px",
        };
      } else if (this.$vuetify.breakpoint.sm) {
        return {
          color: "white",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "16px",
        };
      } else if (this.$vuetify.breakpoint.md) {
        return {
          color: "white",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "18px",
        };
      } else if (this.$vuetify.breakpoint.lg) {
        return {
          color: "white",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "20px",
        };
      } else {
        return {
          color: "white",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "22px",
        };
      }
    },
    fetchCategories() {
      console.log("called");
      this.loading = true;
      PostService.getAcademyCategory()
        .then((res) => {
          this.data = res.data.Children;
          this.data.push({
            CategoryNameTR: "labels.forYou",
            CategoryID: 0,
          });
        })
        .catch((err) => {
          console.error("Error fetching categories:", err);
        })
        .finally(() => {
          this.loading = false;
          console.log(this.data);
        });
    },
  },
};
</script>
